class CollectionMobileSort extends HTMLElement {
  #bound = false;

  connectedCallback() {
    if (this.#bound) return;

    this.#bound = true;
    this.addEventListener('click', this.#onOptionClick.bind(this));
  }

  #onOptionClick(event) {
    const option = event.target.closest('[data-value]');
    if (!option || !this.contains(option)) return;

    event.preventDefault();

    const select = document.getElementById(this.dataset.selectId || 'SortBy');
    if (!select) return;

    const value = option.dataset.value;
    if (select.value !== value) {
      select.value = value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
    }

    this.#setSelected(option);

    const details = this.querySelector('details');
    if (details) details.open = false;
  }

  #setSelected(option) {
    const label = this.querySelector('[data-js-sort-label]');
    if (label) label.textContent = option.dataset.label || option.textContent.trim();

    const existingCheck = this.querySelector('.dropdown-pill__check');
    const checkClone = existingCheck ? existingCheck.cloneNode(true) : null;

    this.querySelectorAll('.dropdown-pill__option--selected').forEach((selected) => {
      selected.classList.remove('dropdown-pill__option--selected');
      const check = selected.querySelector('.dropdown-pill__check');
      if (check) check.remove();
    });

    option.classList.add('dropdown-pill__option--selected');
    if (checkClone) {
      option.append(checkClone);
    }
  }
}

customElements.define('collection-mobile-sort', CollectionMobileSort);

if (!window.collectionMobileDropdownsBound) {
  window.collectionMobileDropdownsBound = true;
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.classList.contains('dropdown-pill') || !details.open) return;

    document.querySelectorAll('details.dropdown-pill[open]').forEach((openDetails) => {
      if (openDetails !== details) openDetails.open = false;
    });
  }, true);
}
